import api from '.';
import { buildQueryWithParams, makeListTags } from '../../Utils/api';

const tagType = 'usersList';

const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createUserRfidTag: builder.mutation({
      query: (data) => ({
        url: `/rfid-tags`,
        method: 'POST',
        body: data
      }),
      transformResponse: (res) => {
        return res;
      }
    }),

    createAdminRfidTag: builder.mutation({
      query: ({ userId, value, status = RFID_TAG_STATUS.ACTIVE }) => ({
        url: `users/${userId}/rfid-tags`,
        method: 'POST',
        body: { value: value, status: status }
      }),
      transformResponse: (res) => {
        return res;
      }
    }),
    updateAdminRfidTag: builder.mutation({
      query: ({ userId, data, where }) => ({
        url: `users/${userId}/rfid-tags?where=${JSON.stringify(where)}`,
        method: 'PATCH',
        body: data
      }),
      transformResponse: (res) => {
        return res;
      }
    }),
    updateUserRfidTag: builder.mutation({
      query: (params) => ({
        url: `/rfid-tags/${params?.rfidTagId}`,
        method: 'PATCH',
        body: params.data
      }),
      transformResponse: (res) => {
        return res;
      }
    })
  })
});

export default usersApi;
export const {
  useCreateUserRfidTagMutation,
  useCreateAdminRfidTagMutation,
  useUpdateUserRfidTagMutation,
  useUpdateAdminRfidTagMutation
} = usersApi;
